<template>
    <div>
    <h3>联系我们</h3>
    <!--百度地图容器-->
    <div style=" padding-left:50px;padding-top:50px;">
        <!-- <baidu-map class="bm-view" ak="uFmWo8OYb1oWHroiGmtSrhg93onnPkBy"
        :center="{lng:116.29456, lat:39.967289}"
        :zoom="17"
        :dragging="true"
        :scroll-wheel-zoom="true">
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT" type="BMAP_NAVIGATION_CONTROL_SMALL"></bm-navigation>
            <bm-overview-map anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :isOpen="false"></bm-overview-map>
            <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
            <bm-marker :position="{lng: 116.29456, lat: 39.967289}" @click="infoWindowOpen"
                :icon="{url:'http://map.baidu.com/image/us_mk_icon.png',size:{width:23, height: 25},
                opts:{imageOffset:{width:-46,height:-21},infoWindowOffset:{width:17,height:1},offset:{width:9,height:25}}}">
                <bm-label title="北京汉宁恒丰医药科技股份有限公司" content="北京市海淀区蓝靛厂东路二号A座写字楼9E-1"
                    :labelStyle="{color: '#333',  borderColor:'#808080', cursor: 'pointer',display: showLabel ? '' :'none'}"
                    :offset="{width: 13, height: -20}"/>
            </bm-marker>
            <bm-info-window :position="{lng: 116.29456, lat: 39.967289}" :show="showInfoWindow" @close="infoWindowClose">
                <b class='iw_poi_title' title='北京汉宁恒丰医药科技股份有限公司'>北京汉宁恒丰医药科技股份有限公司</b><div class='iw_poi_content'>北京市海淀区蓝靛厂东路二号A座写字楼9E-1</div>
            </bm-info-window>
        </baidu-map> -->
        <div style="float: left;" >
            <img src="@/assets/map.png"/>
        </div>
        <div style="width:500px;float: left;">
            <ul>
                <li>
                    <p><strong>详细地址：</strong>北京市海淀区蓝靛厂东路二号A座写字楼9E-1</p>
                    <p><strong>邮&nbsp;&nbsp;编：</strong>100097 </p>
                    <p><strong>客服电话：</strong>010-88872389 </p>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>
<script>
// import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
// import BmNavigation from 'vue-baidu-map/components/controls/Navigation.vue'
// import BmOverviewMap from 'vue-baidu-map/components/controls/OverviewMap.vue'
// import BmScale from 'vue-baidu-map/components/controls/Scale.vue'
// import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
// import BmLabel from 'vue-baidu-map/components/overlays/Label.vue'
// import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow.vue'
export default {
  name: 'Home',
  components: {
    // BaiduMap,
    // BmNavigation,
    // BmOverviewMap,
    // BmScale,
    // BmMarker,
    // BmLabel,
    // BmInfoWindow
  },
  data () {
    return {
      showInfoWindow: true,
      showLabel: false
    }
  },
  mounted () {

  },
  methods: {
    infoWindowOpen () {
      this.showInfoWindow = true
      this.showLabel = false
    },
    infoWindowClose () {
      this.showInfoWindow = false
      this.showLabel = true
    }
  }
}
</script>
<style>
    .bm-view {
        width:450px;height:316px;border:#ccc solid 1px; float:left; margin-bottom:30px;
    }
    .iw_poi_title {
        color: #CC5522;
        font-size: 14px;
        font-weight: bold;
        overflow: hidden;
        padding-right: 13px;
        white-space: nowrap;
    }

    .iw_poi_content {
        font: 12px arial,sans-serif;
        overflow: visible;
        padding-top: 4px;
        white-space: -moz-pre-wrap;
        word-wrap: break-word;
    }
</style>
